import { CreateElement } from "vue";
import { DataModules } from "@/store/modules/data";
import { DefaultFilters as CurrenciesFilters } from "@/data/filters/currencies";
import { DefaultSorters as CurrenciesSorters } from "@/data/sorters/currencies";
import { IImportMappingSource } from "@/models/imports";

import { ICurrency } from "@/models/constants";
import { Sorters } from "@/data/table";

const firstLabel = (h: CreateElement, currency: ICurrency) => {
  return h("p", {}, [
    h(
      "currency-flag",
      {
        class: "has-margin-right-50",
        props: { currencyCode: currency.code }
      },
      currency.name
    ),
    h("strong", { class: "has-margin-right-25" }, currency.code),
    h("span", { class: "has-text-grey" }, `(${currency.name})`)
  ]);
};

export const CurrencySource: IImportMappingSource = {
  props: {
    availableFilters: CurrenciesFilters,
    availableSorters: CurrenciesSorters(),
    usedDataModule: DataModules.CURRENCIES,
    guardFunctionalities: [],
    storeParams: querySearch => {
      return querySearch ? { "filter[code|like]": `%${querySearch}%` } : {};
    },
    initialSorter: () => {
      return {
        field: "code",
        direction: Sorters.ASCENDING
      };
    }
  },
  render: {
    id: (currency: ICurrency) => currency.id,
    firstLabel: (h: CreateElement, currency: ICurrency) =>
      firstLabel(h, currency),
    secondLabel: null,
    media: null
  }
};
